import StudentRoutes from './StudentRoutes';

export default StudentRoutes;
